document.addEventListener('DOMContentLoaded', () => {
  const sections = document.querySelectorAll('.section--scrolling');

  sections.forEach((section, index) => {
    console.log(section)
    const bottom = section.querySelector('.bottom');
    const next = sections[index + 1];
    if (!bottom || !next) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          next.classList.add('stuck');
        } else {
          next.classList.remove('stuck');
        }
      },
      {
        threshold: 1.0
      }
    );

    observer.observe(bottom);
  });
});
